import React from "react";
import CardClass from "../../../CardClass";
import Table from "../../../Table";
import PropTypes from "prop-types";
import { withRouter } from 'react-router-dom';
import MainContext from "../../../../Context/MainContext/MainContext";

export default withRouter(class CardAdminTermList extends CardClass {
    static contextType = MainContext; // For legacy class components

    sortRows(rows) {
        return [...rows].sort((a, b) => {
            const typeCompare = (a.type || "").localeCompare(b.type || "", undefined, { sensitivity: "base" });
            if (typeCompare !== 0) {
                return typeCompare;
            }

            const nameCompare = (a.name || "").localeCompare(b.name || "", undefined, { sensitivity: "base" });
            if (nameCompare !== 0) {
                return nameCompare;
            }

            return (a.id || 0) - (b.id || 0);
        });
    }

    /**
     * Renders the content of the card.
     */
    renderContent() {
        let rows;
        let columns;
        if (this.props.type) {
            rows = Object.values(Object.values(this.context.termsIndexed).filter((term) => {
                return term.type === this.props.type;
            }));
            rows = this.sortRows(rows);
            columns = [
                { key: "id", name: "ID", type: "number" },
                { key: "name", name: "Name", type: "string" },
            ];
        } else {
            rows = Object.values(this.context.termsIndexed);
            rows = this.sortRows(rows);
            columns = [
                { key: "id", name: "ID", type: "number" },
                { key: "type", name: "Type", type: "string", filter: true },
                { key: "name", name: "Name", type: "string" },
            ];
        }

        return (
            <Table
                search={true}
                columns={columns}
                rows={rows}
                onClick={(term) => {
                    const path = this.props.type
                        ? this.props.type.replace(
                            /(_\w)/g,
                            (match) => match[1].toUpperCase()
                        )
                        : "term";

                    this.props.history.push({
                        pathname: `/admin/${path}/${term.id}`
                    });
                }}
            />
        );
    }
});
